// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__D291Y","left":"styles_left__2UhXT"};